import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";

const ScenariosIcons = (props) => {
  const { name, type, icon, toggleScenarioModal } = props;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(!isLoading);
    }, 500);
  }, []);

  return (
    <>
      <div
        className="p-0 sicons cursor d-flex flex-column align-items-center"
        onClick={toggleScenarioModal}
      >
        {!isLoading ? (
          <>
            <div>
              <span className="scenariosCircle d-flex align-items-center justify-content-center">
                <span
                  className={`scenariosIcons d-block rounded-circle ${type} `}
                >
                  <i className={`${icon} d-block font-weight-100`}></i>
                </span>
              </span>
            </div>
            <div>
              <small className="d-block mt-2 fn11">{name}</small>
            </div>
          </>
        ) : (
          <>
            <div>
              <span className="scenariosCircle d-flex align-items-center justify-content-center">
                <Skeleton circle={true} width={35} height={35} />
              </span>
            </div>
            <div className="mt-2">
              <Skeleton width={30} height={10} />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export { ScenariosIcons };
